export default {
      id: "volume-off-usage",
      viewBox: "0 0 16 12",
      url: __webpack_public_path__ + "img/icons.479460d5.svg#volume-off",
      toString: function () {
        return this.url;
      }
    }